import { Component, ElementRef, OnChanges, OnDestroy, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';
import { UserService } from 'src/app/services/user.service';
import { getMatIconFailedToSanitizeUrlError } from '@angular/material/icon';
import { ClientModelService } from '../../shared/client-model/client-model.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { ApiService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { from } from 'rxjs';
import { CryptoService } from 'src/app/services/crypto.service';
import { confirmResetPassword, confirmSignIn, resetPassword, signIn, signOut, setUpTOTP, updateMFAPreference, verifyTOTPSetup,fetchMFAPreference   } from 'aws-amplify/auth';
import { NgForm } from '@angular/forms';
import { Subject, Subscription, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.scss"],
    animations: [
        trigger('fadeAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('2000ms', style({ opacity: 1 })),
            ]),
            transition(':leave', [
                animate('2000ms', style({ opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
export class LoginComponent implements OnInit, OnChanges, OnDestroy  {
  // @ViewChild('loginClose') loginClose: ElementRef<HTMLElement>;
  @ViewChildren('verificationCodeInput') verificationCodeInputs!: QueryList<ElementRef<HTMLInputElement>>;
  user: any;
  showQR: boolean = false;
  mfaMode: boolean = false;
  ConfirmMFaMode: boolean = false;
  isValid: boolean = false;
  loginMode: boolean = true;
  resetMode: boolean = false;
  forgotMode: boolean = false;
  formSubmitted: boolean = false;
  firstTimeReset: boolean = false;
  showPassword: boolean = false;
  qrValue: any;
  backUrl: string = "";
  message: string = "";
  password: any = "";
  username: any = "";
  mfa_answer: string = "";
  mfaMessage: string = "";
  forgot_email: string = "";
  new_password: string = "";
  qrElementType: string = "url";
  confirm_password: string = "";
  verification_code: string = "";
  forgotErrorMessage: string = "";
  new_update_password: string = "";
  confirm_update_password: string = "";
  messageResetPassword: string = "";
  updatePasswordMessage: string = "";
  confirmAccountUrl: string = "/confirm-account";
  homePageURL: string = "home";
  rememberMe: boolean = false;
  loginWithDemoUser: boolean = false;
  currentImageIndex: number = 0;
  images: string[] = [
    'assets/login_frame1New.svg',
    'assets/login_frame2New.svg',
    'assets/login_frame3New.svg',
    'assets/login_frame4New.svg',
  ];
  isResetPasswordSuccess: boolean = false;
  firstTimeEmailCodeMFA: boolean = false;
  setupMethod: string = "EMAIL";
  firstTimeSetup: boolean = false;
  emailMode: boolean = false;
  email_otp: string = '';
  existingMFAPreferenceUpdate:boolean = false;
  existSetUpMethod: string = "";
  methodName: string = "";
  timer = 180;               // 3 minutes = 180 seconds
  isResendDisabled = false;
  isLoggingIn = false;
  isSsoLoggingIn = false;
  ssoErrorMessage = '';
  ssoAvailable = false;
  loginStep: 'choose' | 'password' = 'choose';
  intervalId: any;
  private emailInput$ = new Subject<string>();
  private sub!: Subscription;
  conginoUserStatusDetails: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private sessionService: SessionService,
    public clientModelService: ClientModelService,
    private mixpanelService: MixpanelService,
    private apiService: ApiService,
    private cryptoService: CryptoService,
    private authService: AuthService
  ) {
    let that = this;

    this.ssoAvailable = this.authService.isOktaSsoAvailable();

    this.route.queryParams.subscribe(params => {
      this.existingMFAPreferenceUpdate = params['key'] || null;
      console.log("Key from URL: 91", this.existingMFAPreferenceUpdate);
      this.methodName = this.sessionService.getMfaMethod();
      if (params['ssoError']) {
        this.loginStep = 'choose';
        this.ssoErrorMessage =
          'SSO sign-in failed. Please try again or use password login.';
      }
    });

    if(this.existingMFAPreferenceUpdate) {
      this.loginMode = false;
      this.forgotMode = false;
      this.existingMFAPreferenceUpdate = false;
      this.showQRCode();
    } else {
      this.loginMode = true;
      this.forgotMode = false;
    }

    // this.route.queryParams.subscribe((params: any) => {
    // 	if (params['url']) {
    // 		that.isValid = true;
    // 		this.backUrl = params['url'];
    // 	} else {
    // 		that.isValid = false;
    // 	}
    // });
  }
  cognitoUserStatus:string = "";
  ngOnInit(): void {
    this.getEmailPassLocal()
    setInterval(() => {
      this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
    }, 3000); // Change image every 3 seconds

    this.sub = this.emailInput$
    .pipe(
      debounceTime(600),               // wait for user to stop typing
      distinctUntilChanged(),           // only if value changed
      switchMap(email => {
        const payload = { user_id: email };  // <-- wrap email in payload
        return this.apiService.getCongnitoUserStatus(payload).pipe(
          catchError(err => {
            console.error(err);
            return of(null);
          })
        );
      })
    )
    .subscribe((result:any) => {
      //console.log('API result:', result);
      // handle API result
      this.conginoUserStatusDetails = result.Result;
      this.cognitoUserStatus = this.conginoUserStatusDetails.UserStatus;
    });
  }

   onEmailInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.emailInput$.next(value);
  }

  ngOnChanges(): void {

  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  getEmailPassLocal() {
    if (localStorage.getItem('rememberMe') == 'true') {
      this.rememberMe = true
      this.username = this.sessionService.getUsernameLocal();
      const encyptPassword = this.cryptoService.decryptUsingCrypto(localStorage.getItem('password'));
      this.password = encyptPassword;
    } else if (localStorage.getItem('rememberMe') == 'false') {
      this.rememberMe = false
    }
  }

  onRememberMeChange(event: any) {
    if (event.target.checked == true) {
      localStorage.setItem('rememberMe', 'true')
      this.rememberMe = true;
    } else {
      localStorage.setItem('rememberMe', 'false')
      this.rememberMe = false;
      localStorage.removeItem('username')
      localStorage.removeItem('password')
    }
  }

  onloginWithDemoUser(event:any) {
    this.loginWithDemoUser = !this.loginWithDemoUser
  }

  chooseOktaLogin(): void {
    this.message = '';
    this.ssoErrorMessage = '';
    this.continueOktaLogin();
  }

  choosePasswordLogin(): void {
    const email = (this.username || '').trim();
    if (!email || !email.includes('@')) {
      this.message = 'Enter a valid email address to continue.';
      return;
    }
    this.message = '';
    this.ssoErrorMessage = '';
    this.loginStep = 'password';
  }

  backToLoginChooser(): void {
    this.ssoErrorMessage = '';
    this.message = '';
    this.isSsoLoggingIn = false;
    this.loginStep = 'choose';
  }

  continueOktaLogin(): void {
    const email = (this.username || '').trim();
    if (!email || !email.includes('@')) {
      this.ssoErrorMessage = 'Enter a valid email address to continue with Okta.';
      return;
    }
    this.loginWithOktaSso();
  }

  async loginWithOktaSso(): Promise<void> {
    this.ssoErrorMessage = '';
    this.isSsoLoggingIn = true;
    try {
      // Every click is a fresh sign-in, the way password login is: any session
      // left over — this app's and Cognito's — is dropped rather than resumed,
      // so the user authenticates with Okta instead of landing back in whatever
      // account was signed in before. The browser goes to Hosted UI from here,
      // and /callback finishes the login.
      await this.authService.loginWithOkta(this.username, { forceFresh: true });
    } catch (err: any) {
      console.error('SSO login failed:', err);
      this.ssoErrorMessage =
        err?.message ||
        'Unable to start SSO login. Check Cognito Hosted UI configuration.';
      this.isSsoLoggingIn = false;
    }
  }

  login(Form: any) {
    
    sessionStorage.removeItem('userType');

    this.apiService.login({user_id: this.username,password: this.password}).subscribe((result: any) => { 
      // debugger
      if(result?.success && result?.message && result?.message.includes("Demo")) {
        console.log("Login successfully with DEMO user") 
        sessionStorage.setItem('userType', 'DemoUser');  
        this.sessionService.setUsername(result.username);
        this.sessionService.setUsernameLocal(result.username);
        // this.mixpanelService.setIdentity(result.username);
        // this.mixpanelService.register({"session_id":new Date().getTime()});
        // this.mixpanelService.track("login");
        this.setupUserSession();

        setTimeout(() => {
          this.router.navigate([`${this.backUrl}/${this.homePageURL}/`],{ queryParams: { l: '1' } });
          // window.location.href = this.backUrl + this.homePageURL + "?l=1";
        }, 100);

      } else {
        this.cognitoLogin(Form)
      }
    }, (error: any) => {
      this.cognitoLogin(Form)
    });
  }

  async cognitoLogin(Form: any) {

    await signOut({ global: true }).catch(() => {});

    let that = this;

    this.message = "";
    this.formSubmitted = true;

    if (Form.valid) {
      sessionStorage.clear();

      try {

        const user: any = await signIn({username: this.username,password: this.password,});

        // Save credentials only after successful sign-in
        if (this.rememberMe) {
          this.sessionService.setUsernameLocal(this.username);
          const encyptPassword = this.cryptoService.encryptUsingCrypto(this.password);
          localStorage.setItem('password', encyptPassword);
        } else {
          localStorage.removeItem('username');
          localStorage.removeItem('password');
        }

        // 🔑 In v6 we check `nextStep.signInStep` instead of challengeName
        const step = user.nextStep.signInStep;

        if (step === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
          this.mfaMode = false;
          this.ConfirmMFaMode = false;
          this.loginMode = false;
          this.resetMode = false;
          this.forgotMode = false;
          this.firstTimeReset = true;
          this.resetFirstTimePasswordForm();

        } else if (step === 'CONTINUE_SIGN_IN_WITH_MFA_SETUP') {
          this.loginMode = false;

        } else if (step === 'CONFIRM_SIGN_IN_WITH_TOTP_CODE') {
          this.showMFAVerification();
          this.existSetUpMethod = "TOTP"
          this.sessionService.setMfaMethod(this.existSetUpMethod)

        } else if (step === 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION') {
          this.firstTimeSetup = true;
          this.loginMode = false;

        } else if (step === 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE') {
          this.emailMode = true;
          this.loginMode = false;
          this.existSetUpMethod = "TOTP"
          this.sessionService.setMfaMethod(this.existSetUpMethod)
          console.log('user 199', this.loginMode);

        } else if (step === 'DONE') {
          //await this.setupUserSession();
          // this.userLogActivity(this.username)
          window.location.href = this.backUrl;
         
        } else if(step === 'CONFIRM_SIGN_IN_WITH_EMAIL_CODE') {
          this.emailMode = true;
          this.startTimer();
          this.loginMode = false;
          this.existSetUpMethod = "EMAIL"
          this.sessionService.setMfaMethod(this.existSetUpMethod)
          console.log('user 239', this.loginMode);
        } else if(step === 'EMAIL_OTP') {
          this.emailMode = true;
          this.startTimer();
          this.loginMode = false;
          this.existSetUpMethod = "Email OTP"
          this.sessionService.setMfaMethod(this.existSetUpMethod)
         // this.firstTimeReset = true;
        }
         else {
          console.log('⚠️ Unhandled step:', step);
        }
      } catch (error: any) {
          if (error.name === 'UserNotConfirmedException') {
            this.router.navigate([this.confirmAccountUrl]);
          } else if (error.name === 'NotAuthorizedException') {
            switch (this.cognitoUserStatus) {
              case 'FORCE_CHANGE_PASSWORD':
                this.message = 'The temporary password entered is incorrect. Please re-enter or paste it exactly as provided in the email.'
                break;
              case 'CONFIRMED':
                this.message ="The password entered is incorrect. Please enter correct password.";
                break;
              case 'USER_NOT_FOUND':
                this.message = 'Invalid username. Please enter correct username.';
                break;
              default:
                this.message = 'Invalid username or password';
                break;
            }
          } else if (error.name === 'UsernameExistsException') {
            this.message = 'Invalid username. Please enter correct username.';
          } else {
            this.message = error.message || 'Login failed';
            console.error(error);
          }
        } finally {
          this.isLoggingIn = false;
        }
    } else {
      this.isLoggingIn = false;
    }
  }
  
  secretKey:any
  accountName:any;

  async showQRCode() {
    this.mfa_answer = '';
    this.firstTimeSetup = false;
    this.firstTimeEmailCodeMFA = false;
     this.showQR = true;
    this.accountName = this.username;

    const output = await setUpTOTP();
    this.secretKey = output.sharedSecret;           // Your TOTP secret

    //const uri = output.getSetupUri(`"otpauth://totp/DataUnveilAnalytics?secret=" + ${this.secretKey}`);  // otpauth:// URI for QR

    this.qrValue = "otpauth://totp/DataUnveilAnalytics?secret=" + this.secretKey;

    this.mfaMode = true;
    this.loginMode = false;
    this.firstTimeReset = false;
    this.focusVerificationInput();
  }
 
  copied = false;
  copiedA = false;

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      // Optionally show toast/snackbar to user
      // Optionally show toast/snackbar to user
       this.copied = true;

      // Show tick for 1.5s
      setTimeout(() => {
        this.copied = false;
      }, 1500);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }
  
  copyToAClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      // Optionally show toast/snackbar to user
       this.copiedA = true;

      // Show tick for 1.5s
      setTimeout(() => {
        this.copiedA = false;
      }, 1500);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }

  // userLogActivity(username: any) {
  //   const userActivite={
  //     "user_id": username,
  //     "event_name": "Login"
  //   }

  //   this.apiService.userActivity(userActivite).subscribe((result: any) => { 
  //     console.log("User activity logged successfully");
  //   }, (error: any) => {
  //     console.error("Error logging user activity", error);
  //   });
  // }

  focusVerificationInput() {
    setTimeout(() => {
      const input = this.verificationCodeInputs?.first;
      if (input) {
        input.nativeElement.focus();
      }
    });
  }

  async showMFAVerification() {
    this.ConfirmMFaMode = true;
    this.loginMode = false;
    this.focusVerificationInput();
  }

  async verifyMFA() {
    let result: any;

    this.mfaMessage = "";

    try {
      if (this.showQR) {
       // result = await Auth.verifyTotpToken(this.user, this.mfa_answer);
        result= await verifyTOTPSetup({code: this.mfa_answer});
        await updateMFAPreference({ totp: 'PREFERRED' });
        console.log("result", result);
         this.showLogin();
      } else {

        if (result) {
          // this.userLogActivity(result.username);
          this.sessionService.setUsername(result.username);
          this.sessionService.setUsernameLocal(result.username);
          this.sessionService.setMainUsername(result.username)
          this.mixpanelService.setIdentity(result.username);
          this.mixpanelService.register({"session_id":new Date().getTime()});
          this.mixpanelService.track("Login");
          this.setupUserSession();

          setTimeout(() => {
            this.router.navigate([`${this.backUrl}/${this.homePageURL}/`],{ queryParams: { l: '1' } });
            // window.location.href = this.backUrl + this.homePageURL + "?l=1";
          }, 300);
        } else {
          this.mfaMessage = "Cannot verify authentication code";
        }
      }
    } catch (err: any) {
      switch (err.code) {
        case "NotAuthorizedException":
          this.mfaMessage = "Looks like last session was not logged out";

          setTimeout(() => {
            this.showLogin();
          }, 2000);

          break;

        case "EnableSoftwareTokenMFAException":
          this.mfaMessage = "Invalid code";
          break;

        case "CodeMismatchException":
          this.mfaMessage = "Invalid code";
          break;
      }
    }
  }

  async confirmMFA() {
  try {
    const result = await confirmSignIn({
      challengeResponse: this.mfa_answer, // 6-digit OTP
    });

    if (result.nextStep.signInStep === "DONE") {
      //updateMFAPreference({ totp: 'PREFERRED' })
    this.sessionService.setUsername(this.username);
    this.sessionService.setUsernameLocal(this.username);
    this.sessionService.setMainUsername(this.username)
    this.mixpanelService.setIdentity(this.username);
    this.mixpanelService.register({ session_id: new Date().getTime() });
    this.mixpanelService.track("Login");
      await this.setupUserSession();
       this.router.navigate([`${this.backUrl}/${this.homePageURL}/`],{ queryParams: { l: '1' } });
    }
  } catch (err:any) {
    console.error("❌ MFA verification failed:", err);
    // Amplify v6 errors often have `name` and `message`
  switch (err.name) {
    case "CodeMismatchException":
      this.mfaMessage = "Invalid verification code. Please enter correct code.";
      break;
    case "ExpiredCodeException":
      this.mfaMessage = "Your code has expired. Please request a new one.";
      break;
    case "NotAuthorizedException":
      this.mfaMessage = "You are not authorized to perform this action.";
      break;
    case "UserNotFoundException":
      this.mfaMessage = "User account not found.";
      break;
    default:
      this.mfaMessage = err.message || "Cannot verify authentication code.";
      break;
  }
  }
}

  async confirmSetup() {
    try {

      this.firstTimeSetup = false;
      this.firstTimeReset = false;
      this.firstTimeEmailCodeMFA = true;
      this.focusVerificationInput();


  } catch (err: any) {
    console.error("❌ Failed to update MFA:", err);
    this.message = err?.message || "Failed to update MFA preference.";
  } finally {
    console.log("MFA update request completed.");
  }
}

async validateEmailCode() {
  try {
    const result = await confirmSignIn({
      challengeResponse: this.mfa_answer, // 6-digit OTP
    });

    if (result.nextStep.signInStep === "DONE") {
      // ✅ user is now authenticated, safe to start TOTP setup
       if (this.setupMethod === 'TOTP') {
        await this.showQRCode();
        //this.showQRCode();
      } else if (this.setupMethod === 'EMAIL') {
        await updateMFAPreference({
          email: 'PREFERRED'
        });
        this.showLogin();
      }
      
    } else {
      console.warn("⚠️ User not fully authenticated yet:", result.nextStep.signInStep);
      this.message = "Please complete sign-in before setting up TOTP.";
    }
  } catch(err:any) {
     console.error("❌ confirmSignIn failed:", err);
     this.message = err.message || "Failed to confirm sign-in.";

  }
}

  emailMessage: string = "";
  async verifyEmailCode() {
  this.emailMessage = "";

  try {
    const result:any = await confirmSignIn({
      challengeResponse: this.email_otp,
    });

    // console.log("User activity logged successfully", result);
    // Now you can safely use result.username
    this.sessionService.setUsername(this.username);
    this.sessionService.setUsernameLocal(this.username);
    this.sessionService.setMainUsername(this.username)

    this.mixpanelService.setIdentity(this.username);
    this.mixpanelService.register({ session_id: new Date().getTime() });
    this.mixpanelService.track("Login");

    if (result.nextStep.signInStep === 'DONE') {
      await this.setupUserSession();
       this.router.navigate([`${this.backUrl}/${this.homePageURL}/`],{ queryParams: { l: '1' } });
     // window.location.href = this.backUrl;
    } else {
      console.log("Next step after OTP:", result.nextStep.signInStep);
    }

    setTimeout(() => {
      this.router.navigate(
        [`${this.backUrl}/${this.homePageURL}/`],
        { queryParams: { l: '1' } }
      );
    }, 300);

  } catch (err: any) {
    console.error("Error verifying email", err);

    switch (err?.name) {
         // ✅ use name in Amplify 6
      case "NotAuthorizedException":
        this.emailMessage = "Looks like last session was not logged out";
        setTimeout(() => this.showLogin(), 2000);
        break;

      case "EnableSoftwareTokenMFAException":
      case "CodeMismatchException":
        this.emailMessage = "Invalid code. Please enter the correct code.";
        break;

      case "ExpiredCodeException":
        this.emailMessage = "Your code has expired. Please request a new one.";
        break;

      default:
        this.emailMessage = err.message || "Something went wrong, please try again.";
        break;
    }
  }
}
 @ViewChild('f') form!: NgForm;  // 👈 Capture the template form
  async resendEmailOtp() {
    try {
      // Call signIn again with the same username
      //await signIn({username: this.username,password: this.password});
      this.login(this.form);

      this.message = "A new OTP has been sent to your email.";
    } catch (err: any) {
      console.error("❌ Failed to resend OTP:", err);
      this.message = err.message || "Unable to resend OTP.";
    }
  }

  startTimer() {
    this.isResendDisabled = true;
    this.timer = 180;

    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.timer--;
      if (this.timer <= 0) {
        clearInterval(this.intervalId);
        this.isResendDisabled = false;
      }
    }, 1000);
  }

  async updatePreference() {
    try {

      if(this.setupMethod === 'TOTP') {
        const mfaPref = await fetchMFAPreference();
        console.log("Current MFA preference:", mfaPref);
        // Case 1: User explicitly set TOTP as enabled or preferred
        if (mfaPref.preferred === "TOTP" ||(mfaPref.enabled && mfaPref.enabled.includes("TOTP"))) {
          await updateMFAPreference({ totp: 'PREFERRED' });
          this.logout();
        } else {
          this.existingMFAPreferenceUpdate = false;
          this.showQRCode();
          
        }
         
      } else if(this.setupMethod === 'EMAIL') {
        await updateMFAPreference({
          email: 'PREFERRED'
        });

        this.logout();
      }

    } catch (err: any) {
      console.error("❌ Failed to update MFA:", err);
      this.message = err?.message || "Failed to update MFA preference.";
    }

  }

async logout() {
  const userEmail = this.sessionService.getMainUsername();

  const userActivite: any = {
    user_id: userEmail,
    event_name: 'Logout'
  };

  try {
    // 1️⃣ Get Local IP (LAN or Intranet)
    userActivite.ip_address = await this.getLocalIP().catch(() => 'Unavailable');

    // 2️⃣ Get Geolocation from Browser (if allowed)
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          const { latitude, longitude } = pos.coords;
          userActivite.latitude = latitude;
          userActivite.longitude = longitude;

          // 3️⃣ Reverse-geocode coordinates → location details
          try {
            const geo: any = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
            ).then((res) => res.json());

            userActivite.location_name = geo.display_name || 'Unknown';
            userActivite.city =
              geo.address?.city || geo.address?.town || geo.address?.village || 'Unknown';
            userActivite.state = geo.address?.state || 'Unknown';
            userActivite.country = geo.address?.country || 'Unknown';
          } catch (geoErr) {
            console.warn('Reverse geocode failed', geoErr);
          }

          // 🚀 Send data
          this.sendLogoutActivity(userActivite);
        },
        async (geoError) => {
          console.warn('Geolocation denied', geoError);

          // 🌍 Fallback: Use IP-based lookup if location is blocked
          const ipData: any = await this.getIPInfo();
          Object.assign(userActivite, ipData);

          this.sendLogoutActivity(userActivite);
        }
      );
    } else {
      // ❌ No geolocation support — fallback
      const ipData: any = await this.getIPInfo();
      Object.assign(userActivite, ipData);
      this.sendLogoutActivity(userActivite);
    }
  } catch (error) {
    console.error('Error in logout location fetch:', error);
    this.sendLogoutActivity(userActivite);
  }
}

/** 🔄 Send logout details to backend and finalize logout */
private sendLogoutActivity(data: any): void {
  this.apiService.userActivity(data).subscribe(
    () => {
      console.log('✅ User logout activity logged:', data);
      this.finalLogout();
    },
    (error: any) => {
      console.error('❌ Error logging logout activity', error);
      this.finalLogout();
    }
  );
}

/** 🌍 Fallback IP-based location lookup */
private async getIPInfo(): Promise<any> {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    return {
      ip_address: data.ip,
      latitude: data.latitude,
      longitude: data.longitude,
      location_name: `${data.city}, ${data.region}, ${data.country_name}`,
      city: data.city,
      state: data.region,
      country: data.country_name
    };
  } catch (e) {
    console.warn('IP-based location failed', e);
    return {};
  }
}

/** 💻 Get local IP (works on intranet / LAN) */
private getLocalIP(): Promise<string> {
  return new Promise((resolve, reject) => {
    const pc = new RTCPeerConnection({ iceServers: [] });
    pc.createDataChannel('');
    pc.createOffer()
      .then((offer) => pc.setLocalDescription(offer))
      .catch(reject);

    pc.onicecandidate = (event) => {
      if (!event || !event.candidate) return;
      const candidate = event.candidate.candidate;
      const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/;
      const ipMatch = ipRegex.exec(candidate);
      if (ipMatch) {
        resolve(ipMatch[1]);
        pc.close();
      }
    };

    // Timeout fallback
    setTimeout(() => reject('Timeout'), 3000);
  });
}


  finalLogout() {
    signOut();
      sessionStorage.clear();
      this.mixpanelService.track("Logout");
      this.sessionService.setUser(null);
      this.sessionService.setUsername(null);
      this.sessionService.setMainUsername(null);
      this.sessionService.setLoginTime(null);

      // this.route.navigate(['/login'], navigationExtras);
      window.location.href = 'login';
  }

  async setupUserSession() {
    this.sessionService.setUser(this.username);
    this.sessionService.setUsername(this.username);
    this.sessionService.setUsernameLocal(this.username);
     this.sessionService.setMainUsername(this.username)
    this.sessionService.setUserDisplays(this.username);

  }

  getUserRole(username: string) {
    return new Promise((resolve, reject) => {
      this.userService.getRole(username, "").subscribe(
        (role) => {
          resolve(role);
        },
        () => {
          // ignore log errors
          resolve(null);
        }
      );
    });
  }

  showLogin() {
    this.forgotErrorMessage =''
    this.resetLogin();
    this.mfaMode = false;
    this.ConfirmMFaMode = false;
    this.loginMode = true;
    this.loginStep = 'choose';
    this.isResetPasswordSuccess = false
    this.resetMode = false;
    this.forgotMode = false;
    this.firstTimeReset = false;
    this.firstTimeEmailCodeMFA = false;
  }

  showFirstTimeResetPassword() {
    this.mfaMode = false;
    this.ConfirmMFaMode = false;
    this.loginMode = false;
    this.resetMode = false;
    this.forgotMode = false;
    this.firstTimeReset = true;
  }

  showResetPassword() {
    this.resetForgotPassword();

    this.mfaMode = false;
    this.ConfirmMFaMode = false;
    this.loginMode = false;
    this.resetMode = false;
    this.forgotMode = true;
    this.firstTimeReset = false;
  }

  showUpdatePassword() {
    this.resetUpdatePassword();

    this.mfaMode = false;
    this.ConfirmMFaMode = false;
    this.resetMode = true;
    this.loginMode = false;
    this.forgotMode = false;
    this.firstTimeReset = false;
  }

   sendVerificationCode() {
    this.apiService.forgotPassowrd(this.forgot_email).subscribe(
      async (resp: any) => {

        try {
           const result = await resetPassword({ username: this.forgot_email });
            // result.nextStep tells you what to do next
            if (result.nextStep.resetPasswordStep === "CONFIRM_RESET_PASSWORD_WITH_CODE") {
              this.showUpdatePassword();  // show OTP + new password screen
            } else {
              console.log("Next step in reset password flow:", result.nextStep);
            }
        } catch(err:any) {

        }
      },
      async (error: any) => {
        if(error.error.text == 'Email sent with password reset link')
        {
          const result = await resetPassword({ username: this.forgot_email });
            // result.nextStep tells you what to do next
            if (result.nextStep.resetPasswordStep === "CONFIRM_RESET_PASSWORD_WITH_CODE") {
              this.showUpdatePassword();  // show OTP + new password screen
            } else {
              console.log("Next step in reset password flow:", result.nextStep);
            }
        } else {
        setTimeout(() => {
          this.forgotErrorMessage = error.error.text
      }, 6000)

        }
      }
    )
  }

  async resetPassword() {
    if(this.confirm_password==this.new_password) {
      try {
      const result:any = await confirmSignIn({
        challengeResponse: this.new_password,
        options: {
          userAttributes: {
            name: "test",
            given_name: "test",
          },
        },
      });

      if (result.nextStep.signInStep === "CONTINUE_SIGN_IN_WITH_MFA_SETUP") {
        this.firstTimeSetup = true;
        this.loginMode = false;
      } else if (result.nextStep.signInStep === "CONTINUE_SIGN_IN_WITH_MFA_SELECTION") {
        this.loginMode = false;
      } else if (result.nextStep.signInStep === "DONE") {
       // await signOut();
       this.confirmSetup();
      } else if(result.nextStep.signInStep === "CONFIRM_SIGN_IN_WITH_EMAIL_CODE") {
        this.confirmSetup();
      }else {
        this.loginMode = true;
      }
    } catch (err: any) {
      console.error("❌ Error resetting password:", err);
      this.messageResetPassword = err.message || "Failed to reset password";
    }
    } else {
      this.messageResetPassword = 'Password mismatch';
    }
  }

  async updatePassword() {
    this.updatePasswordMessage = "";

    try {
      await confirmResetPassword({username: this.username,confirmationCode: this.verification_code,newPassword: this.new_update_password});
      this.resetMode = false;
      this.isResetPasswordSuccess = true;
      setTimeout(() => {
        this.resetAll();
        this.showLogin();
      }, 5000);
    } catch(err:any) {
      this.updatePasswordMessage = err.message || "Password reset failed. Please try again.";
    }

  }

  resetLogin() {
    this.password = "";
    this.username = "";
    this.getEmailPassLocal();
  }

  resetForgotPassword() {
    this.forgot_email = "";
  }

  resetUpdatePassword() {
    this.verification_code = "";
    this.new_update_password = "";
    this.confirm_update_password = "";
  }

  resetFirstTimePasswordForm() {
    this.new_password = "";
    this.confirm_password = "";
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  showConfirmPassword: boolean = false;
  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  resetAll() {
    this.user = {};
    this.formSubmitted = false;
    this.message = "";
    this.password = "";
    this.username = "";
    this.forgot_email = "";
    this.new_password = "";
    this.confirm_password = "";
    this.verification_code = "";
    this.new_update_password = "";
    this.confirm_update_password = "";
    this.getEmailPassLocal();
  }

  helpinfoMessage:string = "";
  helpInfo() {
    this.helpinfoMessage = "";
    if(this.loginMode) {
      this.helpinfoMessage = `<ul><li><P><b>New users</b> will receive a temporary password by Email from scraii-support@dataunveil.com with the subject <b>“Your Temporary Password”</b>. Use these credentials to complete the initial setup.</P></li>
<li><P><b>Existing users</b> can log in with their registered Email ID and previously set password.</P></li></ul>
      `;
    } else if(this.firstTimeReset) {
      this.helpinfoMessage = `<ul>
<li>
<p>Set a new password and select an authentication method (Email OTP or Authenticator App) for two-step authentication.</p>
<ul>
<li>
<p><b>Email OTP:</b> A one-time code sent to your registered Email.</p>
</li>
<li>
<p><b>Authenticator OTP:</b> A time-based code from an authenticator app, set up by scanning a QR code or entering a key.</p>
</li>
</ul>
</li>
<li>
<p>Password must be at least 8 characters long, including one lowercase, one uppercase, one number, and one special character.</p>
</li>
</ul>`;
    } else if(this.mfaMode && this.showQR) {
      this.helpinfoMessage = `<ul>
      <li>Download and install the Microsoft Authenticator app on your Android or iOS device.</li>
      <li>
          Open the app and either:
      <ul>
      <li>Scan the QR code from your browser by selecting the QR icon at the bottom right of the app, or</li>
      <li>In the app, tap the “+” icon at the top right, select <b>“Other”</b> as the <b>account type</b>, and choose <b>Enter code manually</b> to copy the <b>Account Name</b> and <b>Secret Key</b> from your browser into the app and click on finish.</li>
      </ul>
      </li>
      <li>After setup, a new entry <b>“DataUnveilAnalytics”</b> will appear in the app with a <b>6-digit</b> code.</li>
      <li>If <b>“DataUnveilAnalytics”</b> already exists, delete it and add the new entry using either QR scan or manual setup.</li>
      <li>This code is valid for <b>30 seconds</b> and must be entered for two-factor authentication at each login.</li>
      </ul>`;
    } else if(this.ConfirmMFaMode) {
      this.helpinfoMessage = `<p>Enter the code from your <b>authenticator app</b> to complete <b>two-step</b> authentication.</p>`;
    } else if(this.firstTimeEmailCodeMFA) {
      this.helpinfoMessage = `<p>Enter the OTP sent to your <b>registered Email</b> to complete <b>two-step</b> authentication.</p>`;
    } else if(this.forgotMode) {
      this.helpinfoMessage = `<p>Enter your registered Email address to receive a reset link.</p>`;
    } else if(this.resetMode) {
      this.helpinfoMessage = "";
    } else if(this.emailMode) {
      this.helpinfoMessage = `<p>Enter the OTP sent to your <b>registered Email</b> to complete authentication. The code is valid for <b>3 minutes</b> from delivery. If it expires, please request a new one.</p>`;
    } else if(this.firstTimeSetup) {
      this.helpinfoMessage = "";
    } else {
      this.helpinfoMessage = "";
    }
  }

  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;
    closeMenu() {
      this.trigger.closeMenu();
    }
}